<template>
  <div v-if="show">
    <div @click="closeMenu" class="backdrop"></div>
    <div @click="closeMenu">
      <slot></slot>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close"],
  methods: {
    closeMenu() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.backdrop {
  /* display: none; */
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

/* .main-nav {
  display: inline-block;
  text-align: left;
  width: calc(100% - 44px);
  vertical-align: middle;
  z-index: 200;
} */
</style>